import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const features = [
  {
    icon: FiIcons.FiBarChart2,
    title: "Live Visual Polls",
    description: "Create multiple-choice or rating polls that update in real-time. Beautifully animated charts keep your audience glued to the screen."
  },
  {
    icon: FiIcons.FiMessageSquare,
    title: "Moderated Q&A",
    description: "Let guests upvote questions so you address what matters most. Full moderation tools allow you to filter and spotlight key inquiries."
  },
  {
    icon: FiIcons.FiCloud,
    title: "Dynamic Word Clouds",
    description: "Visualize collective sentiment. Watch the most popular answers grow in size as your audience submits their thoughts simultaneously."
  },
  {
    icon: FiIcons.FiZap,
    title: "Instant Results Sync",
    description: "Zero latency between submission and display. Whether you have 10 or 10,000 guests, Pollio handles the load with enterprise stability."
  },
  {
    icon: FiIcons.FiShield,
    title: "Anonymous Participation",
    description: "Boost engagement by allowing guests to vote without revealing their identity, encouraging honest and diverse feedback."
  },
  {
    icon: FiIcons.FiPieChart,
    title: "Post-Event Analytics",
    description: "Export deep engagement reports. Understand peak interaction times and sentiment shifts throughout your event sessions."
  }
];

const PollioFeatures = () => {
  return (
    <section className="py-24 bg-slate-50 border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-base font-semibold text-amber-600 tracking-wide uppercase">Interactive Power</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-900 sm:text-4xl">
            Engagement tools designed for impact
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-8 rounded-3xl border border-slate-200 hover:shadow-2xl transition-all duration-300 group"
            >
              <div className="mb-6 inline-flex items-center justify-center p-3 bg-amber-600 rounded-2xl shadow-lg group-hover:scale-110 transition-transform">
                <SafeIcon icon={feature.icon} className="h-6 w-6 text-white" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-4">{feature.title}</h3>
              <p className="text-slate-600 leading-relaxed text-sm">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PollioFeatures;